<template>
  <v-row justify="center">
    <v-dialog v-model="isActive" max-width="800px" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">
            Nueva Actividad
          </span>
        </v-card-title>
        <v-card-text class="mt-10">
          <validation-observer ref="form">
            <v-container >
              <div class="row">
                <div class="col-12 mb-0 pb-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre Actividad"
                    vid="name"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="model.name"
                      type="text"
                      outlined
                      dense
                      :error-messages="errors"
                      label="Nombre Actividad"
                      required
                    />
                  </validation-provider>
                </div>
              </div>
              <div v-for="(item, index) in model.dates" class="row" :key="index">
                <div class="col-4 my-0 py-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Fecha"
                    vid="date"
                    rules="required"
                  >
                    <date-picker ref="date" label="Fecha" v-model="item.date" :error="errors"/>
                  </validation-provider>
                </div>
                <div class="col-3 my-0 py-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Hora Inicial"
                    vid="initialHour"
                    rules="required"
                  >
                    <v-select
                      :items="times"
                      v-model="item.initialHour"
                      item-text="description"
                      item-value="time"
                      outlined
                      dense
                      :error-messages="errors"
                      label="Hora Inicial"
                      required
                    />
                  </validation-provider>
                </div>
                <div class="col-3 my-0 py-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Hora Final"
                    vid="finalHour"
                    rules="required"
                  >
                    <v-select
                      :items="times"
                      v-model="item.finalHour"
                      item-text="description"
                      item-value="time"
                      outlined
                      dense
                      :error-messages="errors"
                      label="Hora Final"
                      required
                    />
                  </validation-provider>
                </div>
                <div class="col-2 my-0 py-0" v-if="model.dates.length > 1">
                  <v-btn
                    color="black"
                    class="text--primary text-none elevation-0"
                    @click="deleteDateRow(index)"
                  >
                    <v-icon color="white">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-0 pt-0">
                  <v-btn
                    color="secondary"
                    class="white--text text-none elevation-0"
                    @click="addDateRow"
                    dark>
                    Agregar
                  </v-btn>
                </div>
              </div>
            </v-container>
          </validation-observer>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveGeneralActivity">
            Aceptar
          </v-btn>
          <v-btn color="red" text @click="close">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import crudServiceMobileMixin from '@/mixins/crudServiceMobileMixin'
import loaderMixin from '@/mixins/loaderMixin'
import notificationMixin from '@/mixins/notificationMixin'
import dateTimeMixin from '@/mixins/dateTimeMixin'
import { GENERAL_ACTIVITIES_URL } from '@/constants/ServicesMobileConstants'

export default {
  name: 'GeneralActivityModal',
  props: {
    fairId: {
      type: Number
    },
    companies: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      datesCount: 1,
      isActive: false,
      model: {
        name: null,
        dates: [
          {
            date: null,
            initialHour: null,
            finalHour: null
          }
        ]
      }
    }
  },
  methods: {
    addDateRow () {
      this.model.dates.push(
        {
          date: null,
          initialHour: null,
          finalHour: null
        }
      )
    },
    deleteDateRow (index) {
      this.model.dates.splice(index, 1)
    },
    close () {
      this.isActive = false
      this.clean()
    },
    clean () {
      this.$refs.form.reset()
      this.model = {
        name: null,
        dates: [
          {
            date: null,
            initialHour: null,
            finalHour: null
          }
        ]
      }
    },
    open (generalActivity) {
      if (generalActivity) {
        this.model.id = generalActivity.id
        this.model.name = generalActivity.name
        const dates = []
        generalActivity.activity_dates.forEach((elem) => {
          dates.push({
            date: elem.date,
            initialHour: elem.initialHour,
            finalHour: elem.finalHour,
            id: elem.id
          })
        })
        this.model.dates = dates
      }
      this.isActive = true
    },
    saveGeneralActivity () {
      this.model.fairId = this.fairId
      this.$refs.form.validate().then((result) => {
        if (result) {
          if (this.model.id) {
            this.putMobile(GENERAL_ACTIVITIES_URL + '/' + this.model.id, this.model)
              .then((res) => {
                this.close()
                this.showSuccess(res.data.success)
                this.$emit('onClose')
              })
          } else {
            this.postMobile(GENERAL_ACTIVITIES_URL, this.model)
              .then((res) => {
                this.close()
                this.showSuccess(res.data.success)
                this.$emit('onClose')
              })
          }
        }
      })
    }
  },
  mixins: [
    crudServiceMobileMixin,
    notificationMixin,
    loaderMixin,
    dateTimeMixin
  ]
}
</script>
